import { render, staticRenderFns } from "./patientFilterModal.vue?vue&type=template&id=e6cab734&scoped=true&"
import script from "./patientFilterModal.vue?vue&type=script&lang=js&"
export * from "./patientFilterModal.vue?vue&type=script&lang=js&"
import style0 from "./patientFilterModal.vue?vue&type=style&index=0&id=e6cab734&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6cab734",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Loading: require('/opt/build/repo/components/Loading.vue').default,DeleteConfirmationModal: require('/opt/build/repo/components/admin/deleteConfirmationModal.vue').default})
